import Rollbar from "rollbar";
import { rollbar as config } from "@/config";

const rollbar: Rollbar = new Rollbar(config);

export default rollbar;
